<template>
  <div class="sf-page"
       v-if="supplier != null">
    <v-snackbar right
                top
                color="success"
                v-model="confirmationSnackbar">
      {{ $t('saved') }}
    </v-snackbar>
    <information-dialog v-bind:dismissButtonLabel="$t('ok')"
                        v-bind:title="$t('customizeYourDesign')"
                        v-model="informationDialog">
      <p>Im Folgenden haben Sie die Möglichkeit Ihren Ordersatz zu individualisieren. Hierzu können Sie ein Logo, ein Hintergrundbild und einen Text bereitstellen. Bitte verwenden Sie nur Text- und Bildelemente von Produkten, die in ihrem Messeordner freigegeben sind. Wir behalten uns vor, abweichende Darstellungen zu entfernen. <span v-if="products.length === 0">Der im Beispiel gezeigte Ordersatz dient nur zur Illustration!</span><span v-else>Die Vorschau zeigt bereits Ihre Artikel so, wie Kunden sie während der Messe sehen.</span> Um Ihnen eine möglichst gute Präsentation zu garantieren, haben wir einige Empfehlungen für Sie:</p>
      <p><strong>Logo</strong>: Stellen Sie Ihr Logo als PNG-Datei mit transparentem Hintergrund und einer Höhe von 320 Pixeln bereit. Die maximale Dateigröße sollte 100 kb nicht überschreiten.</p>
      <p><strong>Hintergrundbild</strong>: Stellen Sie Ihr Hintergrundbild als JPEG-Datei mit einer Mindestgröße von 1200 x 300 Pixeln bereit. Das Hintergrundbild sollte keine Schrift, Logos o. Ä. enthalten, da es je nach Bildschirmgröße möglicherweise abgeschnitten werden kann. Die maximale Dateigröße sollte 300 kb nicht überschreiten.</p>
      <p><strong>Text</strong>: Für den Text empfehlen wir eine Länge von 50–100 Worten.</p>
      <p><strong>Artikelbilder</strong>: Klicken Sie in der Vorschau auf das Bildfeld eines Artikels, um ein Bild hochzuladen. Je Artikel ist genau ein Bild möglich; ein erneuter Upload ersetzt das vorhandene Bild, „Entfernen“ zeigt wieder den Platzhalter. Der Ausschnitt ist immer quadratisch – Sie können ihn beim Hochladen verschieben und zoomen, ohne Änderung wird die Bildmitte verwendet. Empfohlen sind JPG- oder PNG-Dateien mit mindestens 1000 × 1000 Pixeln, das Produkt freigestellt oder vor hellem Hintergrund. Bilder sind an die Artikelnummer gebunden und sofort für Kunden sichtbar; der Upload steht zur Verfügung, sobald Ihre Artikel importiert sind.</p>
    </information-dialog>
    <top-header v-bind:subtitle="$t('subtitle')"
                v-bind:title="$t('design')">
      <template slot="right-button">
        <v-btn color="primary"
               outlined
               v-on:click="showHelp">
          <v-icon left>ti-help-circle</v-icon>
          {{ $t('help') }}
        </v-btn>
        <v-btn color="primary"
               depressed
               v-on:click="updateSupplier">
          <v-icon left>ti-check</v-icon>
          {{ $t('save') }}
        </v-btn>
      </template>
    </top-header>
    <div class="sf-container">
      <design-card v-bind:form="form"
                   v-bind:invitation-code="invitationCode"
                   v-bind:products="products"
                   v-bind:supplier="supplier" />
    </div>
  </div>
</template>

<script>
  import InformationDialog from '@/components/common/InformationDialog'
  import TopHeader from '@/components/common/TopHeader'
  import DesignCard from '@/components/registration/DesignCard'

  export default {
    async beforeRouteUpdate(to, from, next) {
      const invitationCode = to.params.invitationCode

      await this.get(invitationCode)

      next()
    },
    components: {
      DesignCard,
      InformationDialog,
      TopHeader
    },
    async created() {
      const invitationCode = this.$route.params.invitationCode

      await this.get(invitationCode)

      this.informationDialog = true
    },
    data: () => ({
      form: {},
      informationDialog: false,
      invitationCode: null,
      products: [],
      supplier: null,
      confirmationSnackbar: false
    }),
    methods: {
      async get(invitationCode) {
        this.invitationCode = invitationCode

        await this.$store.dispatch('loadSupplierByInvitationCode', { invitationCode })

        const supplier = this.$store.getters.supplierByInvitationCode(invitationCode)

        if (supplier == null) {
          this.$router.push({ name: 'home' })
        }

        if (supplier.state !== 'accepted') {
          this.$router.push({ name: 'registration-supplier', params: { invitationCode } })
        }

        this.supplier = Object.assign({}, supplier)
        this.products = await this.$store.dispatch('loadProductsForDesignPreview', { supplierId: supplier.id, invitationCode })
      },
      async showHelp() {
        this.informationDialog = true
      },
      async updateSupplier() {
        await this.$store.dispatch('updateSupplier', { supplier: this.supplier })

        this.confirmationSnackbar = true

       // this.$router.push({ name: 'home' })
      }
    },
    name: 'SupplierDesign'
  }
</script>

<i18n>
  {
    "de": {
      "back": "Zurück",
      "customizeYourDesign": "Passen Sie Ihr Design an",
      "design": "Design",
      "ok": "Ok",
      "save": "Speichern",
      "saved": "Vielen Dank! Ihr Design wurde gespeichert.",
      "help": "Hinweise",
      "subtitle": "Gestalten Sie Ihren Ordersatz mit Logo, Hintergrundbild und Text"
    },
    "en": {
      "back": "Back",
      "customizeYourDesign": "Customize your design",
      "design": "Design",
      "ok": "Ok",
      "save": "Save",
      "saved": "Thank you! Your design has been saved.",
      "help": "Hints",
      "subtitle": "Customise your order sheet with logo, background image and text"
    }
  }
</i18n>